export default __webpack_public_path__ + "static/media/java.a6e4d40e.svg";